import { CommonProp } from '@acin/ui-core';
import React from 'react';

interface IContext {
  regulationId: string;
}

const INITIAL_STATE: IContext = {
  regulationId: '',
};

export const Context = React.createContext(INITIAL_STATE);

export const useRegulationDetail = () => React.useContext(Context);

export interface RegulationDetailProviderProps extends CommonProp {
  regulationId: string;
}

export const RegulationDetailProvider: React.FC<RegulationDetailProviderProps> = ({ regulationId, children }) => {
  return <Context.Provider value={{ regulationId }}>{children}</Context.Provider>;
};
